<template>
  <div>
    <!-- header -->
    <header>
      <section
        class="w-full p-1 min-h-[7vh] flex justify-end border border-gray-300 rounded-2xl"
      >
        <button
          id="dropdownAvatarNameButton"
          data-dropdown-toggle="dropdownAvatarName"
          class="flex items-center text-sm pe-1 font-medium text-gray-600 rounded-full hover:text-gray-950 md:me-0 focus:ring-4 focus:ring-gray-100"
          type="button"
        >
          <span class="sr-only">Open drop</span>
          <img
            class="w-11 h-11 rounded-full"
            :src="profileImg"
            :alt="profileImg"
          />

          <div class="pl-2 mt-auto mb-auto text-left">
            <div class="text-base font-semibold">
              {{
                profileName.length > 10
                  ? profileName.slice(0, 10).concat("...")
                  : profileName
              }}
            </div>

            <div class="font-normal text-gray-500 -mt-2">
              <small>
                {{
                  profileRole?.length > 10
                    ? profileRole.slice(0, 10).concat("...")
                    : profileRole
                }}
              </small>
            </div>
          </div>

          <div class="mt-auto mb-auto ml-2">
            <component :is="PhCaretDown" class="h-4 w-4" />
          </div>
        </button>

        <!-- Dropdown options -->
        <div
          id="dropdownAvatarName"
          class="z-40 hidden bg-white divide-y divide-gray-100 rounded-lg shadow w-44"
        >
          <div class="px-0.5 py-3 text-sm text-gray-900">
            <p>
              {{
                companyName?.length > 20
                  ? companyName.slice(0, 20).concat("...")
                  : companyName
              }}
            </p>
          </div>

          <ul
            class="py-2 text-sm text-gray-700"
            aria-labelledby="dropdownInformdropdownAvatarNameButtonationButton"
          >
            <li>
              <a
                aria-disabled="true"
                class="block px-4 py-2 bg-gray-200 cursor-not-allowed"
              >
                <p class="flex justify-center w-full">
                  <component
                    class="h-4 w-4 mt-auto mb-auto mr-2"
                    :is="PhBuildingApartment"
                  ></component>
                  Filiais
                </p>
              </a>
            </li>

            <li>
              <router-link
                class="block px-4 py-2 hover:bg-gray-100"
                to="/profile"
              >
                <p class="flex justify-center w-full">
                  <component
                    class="h-4 w-4 mt-auto mb-auto mr-2"
                    :is="PhUser"
                  ></component>
                  Meu perfil
                </p>
              </router-link>
            </li>
            <li>
              <!-- <a href="#" class="block px-4 py-2 hover:bg-gray-100">
                Empresa
              </a> -->
              <router-link
                class="block px-4 py-2 hover:bg-gray-100"
                to="/company"
              >
                <p class="flex justify-center w-full">
                  <component
                    class="h-4 w-4 mt-auto mb-auto mr-2"
                    :is="PhBuilding"
                  ></component>
                  Empresa
                </p>
              </router-link>
            </li>
          </ul>
          <div class="py-2">
            <router-link
              class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              to="/logout"
            >
              <p class="flex justify-center w-full">
                <component
                  class="h-4 w-4 mt-auto mb-auto mr-2"
                  :is="PhSignOut"
                ></component>
                Sair
              </p>
            </router-link>
          </div>
        </div>
      </section>
    </header>

    <!-- titlo e ações -->
    <section class="px-3 pb-2">
      <div class="flex justify-between p-1 md:p-1 w-full">
        <div class="md:mt-0 text-left mt-auto mb-auto">
          <h1
            class="font-extrabold text-gray-900 dark:text-white md:text-5xl lg:text-4xl"
            :class="[small ? 'text-2xl' : 'text-4xl']"
          >
            <span
              class="text-transparent bg-clip-text bg-gradient-to-r to-[#93cd24] from-[#0c7036]"
            >
              <slot />
            </span>
          </h1>
          <div class="w-full text-left">
            <small class="text-left font-normal text-gray-500">
              {{ props.subTitle }}
            </small>
          </div>
        </div>

        <div class="mt-auto mb-auto">
          <slot name="action" />
        </div>
      </div>
    </section>

    <div class="-mt-2 p-1 mb-auto justify-end flex">
      <slot name="b-action" />
    </div>
  </div>
</template>

<script setup>
import {
  PhBuilding,
  PhBuildingApartment,
  PhCaretDown,
  PhSignOut,
  PhUser,
} from "@phosphor-icons/vue";
import { initFlowbite } from "flowbite";
import { storeApp } from "@/store";
import { defineProps, onMounted, computed, watch, ref } from "vue";

const props = defineProps({
  subTitle: {
    type: String,
    require: false,
  },
  small: {
    type: Boolean,
    require: false,
  },
});

const companyName = ref("");
watch(
  () => localStorage.getItem("__company_name"),
  (newVal) => {
    if (newVal == null || newVal == undefined) {
      companyName.value = "";
    } else {
      storeApp.dispatch("setCompanyName", {
        key: "__company_name",
        value: newVal,
      });
      companyName.value = newVal;
    }
  },
  { immediate: true }
);

const profileName = ref("");
watch(
  () => localStorage.getItem("__user_name"),
  (newVal) => {
    if (newVal == null || newVal == undefined) {
      profileName.value = "";
    } else {
      storeApp.dispatch("setUserName", { key: "__user_name", value: newVal });
      profileName.value = newVal;
    }
  },
  { immediate: true }
);

const profileRole = ref("");
watch(
  () => localStorage.getItem("__user_role"),
  (newVal) => {
    if (newVal == null || newVal == undefined) {
      profileRole.value = "";
    } else {
      storeApp.dispatch("setUserRole", { key: "__user_role", value: newVal });
      profileRole.value = newVal;
    }
  },
  { immediate: true }
);

const profileImg = ref("");
watch(
  () => localStorage.getItem("__user_photo"),
  (newVal) => {
    if (
      newVal == null ||
      newVal == "null" ||
      newVal == undefined ||
      newVal == ""
    ) {
      profileImg.value = require("@/assets/logo/protege.png");
    } else {
      storeApp.dispatch("setUserPhoto", { key: "__user_photo", value: newVal });
      profileImg.value =
        process.env.VUE_APP_IMAGE_SERVE.concat("storage/") + newVal;
    }
  },
  { immediate: true }
);

onMounted(() => {
  initFlowbite();
});
</script>
